import React, { useEffect, useState } from "react";
import { LoginAdapter } from "../../../../../infraestructure/persistence/rest/LoginAdapter";
import { ServerErrorMessage } from "../../../../../shared/utils/error";
import Formulario from "./formulario";
import sessionProvider from "../../../../../shared/utils/session";
import { useNotifications } from "../../../../../shared/hooks/Notifications";

const { setUserData, guardar } = sessionProvider.create(sessionStorage);

export const FormularioLogin = (props:any) =>{

  let {onSignInCompleted} = props;
  const api = new LoginAdapter();
  const {resultError, exceptionError} = useNotifications();
  let [ user, setUser ] = useState<any>(undefined);
	let result: any;
  
  useEffect(()=>{if(user){onSignInCompleted && onSignInCompleted()}},[user])

  const storeSessionToken = (data?: any) => {
    return new Promise((resolve:any, reject) => {
      try {
        guardar(data.jwt, data);
        resolve();
      } catch (error) {
        reject();
      }
    });
  };

  const storeSessionUserData = (data: any) => {
    return new Promise((resolve:any, reject) => {
      try {
        setUserData(data);
        resolve();
      } catch (error) {
        reject();
      }
    });
  };
  
	const login = async (user:string, password:string) => {
    let usuario={nombre:user, contraseña:password}
		try {
      result = await api.Login(usuario);
      if(result.data && result.data!=="")
			{
        await storeSessionToken(result.data);
        await storeSessionUserData(result.data);
        setUser(usuario);
        return true;
      }else{resultError();return false}
  } catch (error) {
			let exception = ServerErrorMessage(error);
      exceptionError(exception)
      return false
		}
  };
  
  return <Formulario onLogin={login}/>
}